export default "__VITE_ASSET__Cfl4Kik9__"